



















































































































































































































import { Component } from 'vue-property-decorator';
import UUIFComponent from '@/shared/uuifComponent';
import { State } from 'vuex-class';
import { RootStoreState } from '@/store';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { SwStatusInfo } from '@sonicwall/unified-ui-framework/src/shared/sw-status-info';
import { SwScrollView } from '@libs-uuif/shared/sw-scroll-view';
import AddPrefFileDialog from './addPrefFileDialog.vue';
import PrefrenceFileUnit from './prefrencefile-unit.vue';

const cssPrefix = 'cloudbackups';
@Component({
  components: {
    ...UUIFComponent,
    SwStatusInfo,
    AddPrefFileDialog,
    PrefrenceFileUnit,
    SwScrollView,
  },
})
export default class CloudBackups extends SwExtendedVue {
  @State((state: RootStoreState) => state.MswProductsStoreModule.selectedSerialNumer)
  serialNumber: string;
  cssPrefix = cssPrefix;
  nsmLearnMoreUrl: string = 'https://www.sonicwall.com/support/knowledge-base/kA1VN000001Hb2b0AC';
  msg : { infoType : string; infoMsg: string[] } = { infoType: '', infoMsg: [] };
  cloudBackupPermission: boolean = false;
  emptypref: boolean = false;
  cloudPermissionMesssage: string = '';
  showAddPrefFileDialog: boolean = false;
  backupPreference: any = {};
  preferenceFiles: any[] = [];
  downloadPopupText: string = '';
  mounted() {
    this.getBackupPreferences();
  }
  getBackupPreferences() {
    this.cloudBackupPermission = false;
    this.emptypref = false;
    this.$store.dispatch('MswProductsStoreModule/getBackupPref', { serialNumber : this.serialNumber })
    .then((resp) => {
      this.$store.commit('stopLoading');
      this.$store.commit('MswProductsStoreModule/setSkipLoading', 'NO');
      if (resp.operationStatus === 'NOK' && resp.msgCode === 'SNBUNAUTHORIZED') {
        this.cloudPermissionMesssage = resp.msg;
        this.cloudBackupPermission = false;
      } else {
        this.cloudBackupPermission = true;
        this.backupPreference = resp.content;
        this.preferenceFiles = [];
        if (Number(resp.content.prefFileCount) <= 0) {
          this.emptypref = true;
          this.msg.infoType = 'informational';
          this.msg.infoMsg = [];
          this.msg.infoMsg.push(`${this.$t('products.nobackups')}`);
          this.msg.infoMsg.push(`${this.$t('products.nobackups1')}`);
          return;
        }
        this.preferenceFiles = this.backupPreference?.prefFileVerList || [];
        this.downloadPopupText = this.backupPreference?.downloadPopupText || '';
        this.preferenceFiles.map((preferenceFile: any) => {
          preferenceFile.openAccordian = false;
          preferenceFile.preferenceFileId = `preferenceFilesId-${Math.floor(Math.random() * 10000) + 1}`;
        });
      }
    })
    .catch((e) => {
      this.$store.commit('stopLoading');
      console.warn(e);
    });
  }
  addPrefFile() {
    this.showAddPrefFileDialog = true;
  }
  onCloseAddPrefFileDialog(value: boolean) {
    this.showAddPrefFileDialog = false;
    if (value) {
      this.$emit('update-product-details');
      this.getBackupPreferences();
    }
  }
  get getPreferenceFiles() {
    return this.preferenceFiles;
  }
}
